import { Component, Inject, Input } from "@angular/core"
import { MAT_DIALOG_DATA } from "@angular/material/dialog"
import { LexTranslateService } from "@app/core/services/lex-translate.service"

interface DialogData {
  icon: string
  title: string
  paragraph: string
  question: string
  buttonText?: string
  onlyOneBtn?: boolean
}

@Component({
  selector: "seb-generic-dialog",
  templateUrl: "./generic-dialog.component.html",
  styleUrls: ["./generic-dialog.component.css"],
})
export class GenericDialogComponent {
  constructor(
    public lextranslate: LexTranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.data.buttonText = this.data.buttonText || this.lextranslate.i18n["a6fbd8eb-1255-4665-9421-5c818dd4fc27"]
    this.data.onlyOneBtn = this.data.onlyOneBtn || false
  }
}
